import React from 'react';
import {
  MenuPopoverContent,
  Popover,
  PopoverAnchor,
  PopoverTrigger,
} from '../../../../../../../components/Common/UI/Popover';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { IDeliveryModal } from '../index';

interface IDeliverySettings {
  statement: IDeliveryModal['statement'];
  handleOpen: ({ open, statement, type }: IDeliveryModal) => void;
  disableOpen?: boolean;
}

function DeliverySettings({ handleOpen, statement, disableOpen = false }: IDeliverySettings) {
  return (
    <Popover>
      {disableOpen ? (
        <PopoverAnchor className="border rounded-[3px] border-status-late" style={{ marginTop: 1 }}>
          <Icons.ArrowRight style={{ transform: 'rotate(-90deg)' }} />
        </PopoverAnchor>
      ) : (
        <PopoverTrigger className="border rounded-[3px] border-status-late" style={{ marginTop: 1 }}>
          <Icons.ArrowRight style={{ transform: 'rotate(90deg)' }} />
        </PopoverTrigger>
      )}
      <MenuPopoverContent className="mt-[5px] min-w-[100px]" align="start" wrapperClassName="hover:child:bg-white">
        <Button
          className="flex gap-[5px] font-[14px] w-full items-center h-auto !px-[10px] !py-[5px] bg-white"
          variant="ghost"
          onClick={() => handleOpen({ open: true, statement, type: 'edit' })}
        >
          <Icons.EditNew className="w-[13px] h-[13px]" />
          Edit
        </Button>
        <Button
          className="flex gap-[5px] font-[14px] w-full items-center h-auto !px-[10px] !py-[5px] bg-white"
          variant="ghost"
          onClick={() => handleOpen({ open: true, statement, type: 'history' })}
        >
          <Icons.JobStatus className="w-[13px] h-[13px]" />
          History
        </Button>
      </MenuPopoverContent>
    </Popover>
  );
}

export default DeliverySettings;
